import { useCustomDeleteDailyFormVehicleServicePlanMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useDeleteDailyFormVehicleServicePlan() {
  const [mutation, { loading, data, error }] = useCustomDeleteDailyFormVehicleServicePlanMutation();

  const [deleteDailyFormVehicleServicePlan, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "deleteDailyFormVehicleServicePlan",
    },
    { hideMessage: true }
  );

  return [deleteDailyFormVehicleServicePlan, context] as const;
}
